<div class="lem-toasts" role="status" aria-live="polite">
  @for (item of items(); track item.id) {
    <div class="lem-toast" [class]="'lem-toast--' + item.kind">
      <span class="lem-toast__message">{{ item.message }}</span>
      <button
        type="button"
        class="lem-toast__close"
        (click)="dismiss(item.id)"
        aria-label="Fermer la notification"
      >
        ×
      </button>
    </div>
  }
</div>
